<template>
  <v-container class="mt-10">
    <v-row>
     <v-col
      cols="12"
      >
        <v-card-text class="headline">
          Тема: "Первичные средства пожаротушения, автоматические установки пожарной сигнализации и пожаротушения"
        </v-card-text>
     </v-col>
     <v-col cols="6">
          <v-timeline
            align-top
            dense
          >
            <v-timeline-item
              v-for="theme in themes"
              :key="theme.id"
              :color="theme.color"
              small
            >
              <div>
                <div class="headline font-weight-light">{{ theme.theme }}</div>
              </div>
            </v-timeline-item>
          </v-timeline>
      </v-col>
      <!-- /theme -->
      <!-- img -->
      <v-col cols="6">
      <v-card class="pa-5 mb-5">
        <v-img
          height="200px"
          src="img/material/bg-theme-4.svg"
          contain
          class="pa-5"
        >
        </v-img>
      </v-card>
      <!-- /img -->
      <v-card flat>
        <v-card-text class="subtitle-1">
          <v-icon
          color="red"
          class="mr-3"
          >
          mdi-cursor-default-click-outline</v-icon>
          Для изучения дополнительной информации, нажимайте на кнопки или активные элементы
        </v-card-text>
        <v-card-text class="subtitle-1">
          <v-icon
          color="red"
          class="mr-3"
          >
          mdi-arrow-left-right</v-icon>
          Для перемещения по разделам используйте кнопки "Вперед" и "Назад" в виде стрелок
        </v-card-text>
        <v-card flat class="d-flex justify-center mt-10">
          <v-btn
          color="red"
          dark
          to="page28"
          >
            Перейти к изучению
          </v-btn>
        </v-card>
      </v-card>
      </v-col>

    </v-row>
  </v-container>
</template>
<script>
export default {
  data: () => ({
    themes: [
      {
        id: 1,
        theme: 'Первичные средства пожаротушения',
        color: 'red'
      },
      {
        id: 2,
        theme: 'Порошковый огнетушитель',
        color: 'red'
      },
      {
        id: 3,
        theme: 'Углекислотный огнетушитель',
        color: 'red'
      },
      {
        id: 4,
        theme: 'Аэрозольный огнетушитель',
        color: 'red'
      },
      {
        id: 5,
        theme: 'Воздушно-пенный огнетушитель',
        color: 'red'
      },
      {
        id: 6,
        theme: 'Автоматическая установка пожаротушения (АУП)',
        color: 'red'
      },
      {
        id: 7,
        theme: 'Автоматическая установка пожарной сигнализации (АУПС)',
        color: 'red'
      },
      {
        id: 8,
        theme: 'Нормы обеспечения учреждений средствами пожаротушения',
        color: 'red'
      }
    ]
  })
}
</script>
